// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.ContactForm_topic__8QHaw {
    font-size: 3rem;
    font-style: normal;
    font-weight: 600;
    margin-bottom: 3rem;
}

.ContactForm_outerContainer__R954N {
    background-color: #C8D3E6;
    border-radius:0.5rem;
}

.ContactForm_formContainer__jqeAX {
    background-color: #FFF;
    border-radius: 0.5rem;
    margin: 3rem;
    padding: 3rem;
    padding-bottom: 0;
    /* width: 90%; */
}

.ContactForm_formHeading__2wK-m {
    color: #9747FF;
    font-size: 3rem;
    font-style: normal;
    font-weight: 700;
}

.ContactForm_formInput__344dA {
    color: #9747FF;
    font-style: normal;
    font-weight: 500;
    margin-top: 4rem;
}

.ContactForm_button__K-0Hu {
    margin: 4rem 0;
    padding: 1.5rem 4rem;
    font-size: 1.25rem;
    border-radius: 0.5rem;
}

.ContactForm_bottonIcon__Ni6n1 {
    margin-right: 1rem;
    rotate: -45deg;
}

@media (min-width: 771px) {
    .ContactForm_imageMobile__XFIDk {
        display: none;
    }
}

@media (max-width: 770px) {
    .ContactForm_image__88oct {
        display: none;
    }

    .ContactForm_imageMobile__XFIDk{
        height: 14rem;
        width: 8rem;
        margin-top: auto;
    }

    .ContactForm_formContainer__jqeAX {
        margin: 1rem;
        padding: 1rem;
        padding-bottom: 0;
    }

    .ContactForm_formHeading__2wK-m {
        font-size: 2.25rem;
    }

    .ContactForm_button__K-0Hu {
        font-size: 1rem;
        padding: 0.5rem 1rem;
        margin: 2rem 0;
    }

    .ContactForm_bottonIcon__Ni6n1 {
        margin-right: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/ContactUs/ContactForm.module.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["\r\n\r\n.topic {\r\n    font-size: 3rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin-bottom: 3rem;\r\n}\r\n\r\n.outerContainer {\r\n    background-color: #C8D3E6;\r\n    border-radius:0.5rem;\r\n}\r\n\r\n.formContainer {\r\n    background-color: #FFF;\r\n    border-radius: 0.5rem;\r\n    margin: 3rem;\r\n    padding: 3rem;\r\n    padding-bottom: 0;\r\n    /* width: 90%; */\r\n}\r\n\r\n.formHeading {\r\n    color: #9747FF;\r\n    font-size: 3rem;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n}\r\n\r\n.formInput {\r\n    color: #9747FF;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    margin-top: 4rem;\r\n}\r\n\r\n.button {\r\n    margin: 4rem 0;\r\n    padding: 1.5rem 4rem;\r\n    font-size: 1.25rem;\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.bottonIcon {\r\n    margin-right: 1rem;\r\n    rotate: -45deg;\r\n}\r\n\r\n@media (min-width: 771px) {\r\n    .imageMobile {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media (max-width: 770px) {\r\n    .image {\r\n        display: none;\r\n    }\r\n\r\n    .imageMobile{\r\n        height: 14rem;\r\n        width: 8rem;\r\n        margin-top: auto;\r\n    }\r\n\r\n    .formContainer {\r\n        margin: 1rem;\r\n        padding: 1rem;\r\n        padding-bottom: 0;\r\n    }\r\n\r\n    .formHeading {\r\n        font-size: 2.25rem;\r\n    }\r\n\r\n    .button {\r\n        font-size: 1rem;\r\n        padding: 0.5rem 1rem;\r\n        margin: 2rem 0;\r\n    }\r\n\r\n    .bottonIcon {\r\n        margin-right: 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topic": `ContactForm_topic__8QHaw`,
	"outerContainer": `ContactForm_outerContainer__R954N`,
	"formContainer": `ContactForm_formContainer__jqeAX`,
	"formHeading": `ContactForm_formHeading__2wK-m`,
	"formInput": `ContactForm_formInput__344dA`,
	"button": `ContactForm_button__K-0Hu`,
	"bottonIcon": `ContactForm_bottonIcon__Ni6n1`,
	"imageMobile": `ContactForm_imageMobile__XFIDk`,
	"image": `ContactForm_image__88oct`
};
export default ___CSS_LOADER_EXPORT___;
